import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bc2a7ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: '',
  },
  keyName: {
    type: String,
    default: '',
  },
  maxWidth: Boolean,
  defaultSort: String,
},
  setup(__props) {

const props = __props

const router = useRouter()
const route = useRoute()

const handleSort = () => {
  let query = Object.entries(route?.query)
    .map((e) => {
      return { id: e[0], value: e[1] }
    })
    .filter((item: any) => !['asc', 'desc'].includes(item.value))

  router.push({
    path: route.path,
    query: {
      ...Object.fromEntries(
        query.map((item) => {
          return [item.id, item.value]
        })
      ),
      [props.keyName]: checkDefaultSort(route?.query[props.keyName], props.defaultSort) === 'desc' ? 'asc' : 'desc',
      page: 1,
    },
  })
}



const checkDefaultSort = (sortQuery: string, defaultSort: string) => {
  if (sortQuery) return sortQuery
  if (Object.values(route?.query).includes('desc') || Object.values(route?.query).includes('asc')) return ''
  return defaultSort
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleSort()), ["prevent"])),
    class: "cursor-pointer d-flex align-items-center justify-content-center"
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(__props.maxWidth ? 'wi-max-content' : ''),
      innerHTML: __props.title
    }, null, 10, _hoisted_1),
    _createElementVNode("span", {
      class: _normalizeClass([checkDefaultSort(_unref(route)?.query[__props.keyName], __props.defaultSort) && 'active-sort', checkDefaultSort(_unref(route)?.query[__props.keyName], __props.defaultSort) === 'desc' ? 'down' : 'up'])
    }, null, 2)
  ]))
}
}

})